// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"pU4PY2X_D9FCZNmLwCsO","vertical":"GfJFiGClohrE07HDDxpL"};